import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Add_Comment,
  Delete_All_Action_For_One_Lead,
  Get_All_Selected_User_Comments,
  Get_Error,
  Get_Last_200_Comment_For_Admin_Dashboard,
  GetAllActionsDataDashboardType,
  GetAllActionsType,
  Insert_Comment_Replay,
  Update_Selected_Comment,
} from '../Types';
import usedeletedata from '../../Hooks/useDeleteData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';

//get all comment data====>action
export const GetActionsData_action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Action?leed=${id}`);

    dispatch({
      type: GetAllActionsType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all comment data====>action
export const GetActionsData_With_Pages_action = (page) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Action?limit=20000&page=${page}`);

    dispatch({
      type: GetAllActionsType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetAllcomments_Data_With_Pagination_action_advanced = (params) => async (dispatch) => {
  try {
    // params يجب أن يكون object به leadId و userId
    const { leadId, userId, page = 1, limit = 20 } = params || {};

    if (!leadId || !userId) {
      throw new Error('leadId and userId are required');
    }

    // بناء URL مع query parameters
    const url = `/api/v1/Action/actions/${leadId}/user/${userId}/comments?page=${page}&limit=${limit}`;

    const res = await usegetdata(url);

    dispatch({
      type: GetAllActionsType,
      payload: res,
    });

    return res; // إرجاع الـ response لاستخدامه في الـ component
  } catch (e) {
    console.error('Error fetching comments:', e);
    dispatch({
      type: Get_Error,
      payload: e.response || { message: e.message },
    });
    throw e; // إعادة throw الخطأ للتعامل معه في الـ component
  }
};

export const Get_Last_200_Comment_For_Ddmin_Dashboard_Action = (page = 1, limit = 10) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Action/actions/Lastcommentsforadminsdashboard?page=${page}&limit=${limit}&daysBack=60`);
    
    dispatch({
      type: Get_Last_200_Comment_For_Admin_Dashboard,
      payload: res,
    });
    
    return res; // عشان نستخدم الـ return في الكومبوننت
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response?.data || e.message,
    });
    throw e;
  }
};

//insert new comment data=====>action
export const InsertNewAction_action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Action`, body);

    dispatch({
      type: Add_Comment,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all comment data====>action
export const GetAllActionsDatadashboard_action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Action?sort=-createdAt&limit=30000`);

    dispatch({
      type: GetAllActionsDataDashboardType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// get all comments action for marketer dashboard
export const GetAllActionsDatadashboardMarketer_action = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(
      `/api/v1/Action/actions/by-lead-added-email?email=${email}&sort=-createdAt`,
    );

    dispatch({
      type: GetAllActionsDataDashboardType,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//delete all comments for one lead====>action
export const Delete_All_Comments_For_One_Lead = (leedid) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Action/delete-comments/${leedid}`);

    dispatch({
      type: Delete_All_Action_For_One_Lead,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Insert_Comment_Replay_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Action/reply`, body);

    dispatch({
      type: Insert_Comment_Replay,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response ? e.response.data : e.message, // التعامل مع الخطأ بشكل صحيح
    });
  }
};

//get all comment data====>action
export const GetALL_Comments_For_User = (email) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Action/comments/${email}`);

    dispatch({
      type: Get_All_Selected_User_Comments,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const Update_Comment_Action = (commentid, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Action/comment/${commentid}`, body);

    dispatch({
      type: Update_Selected_Comment,
      payload: res,
    });

    return res; // 👈 هذا يُعيد promise للـdispatch
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response, // صحح هنا أيضًا من e.res إلى e.response
    });
    throw e; // 👈 أعد الخطأ ليتم التقاطه في الكومبوننت
  }
};
